import React, { Component } from 'react';
import { Button, Modal, Card, Row, Form, Col, Tabs, Tab } from 'react-bootstrap';
import BootstrapTable from 'react-bootstrap-table-next';
import ToolkitProvider, { Search } from 'react-bootstrap-table2-toolkit';
import paginationFactory, { PaginationProvider, PaginationListStandalone, SizePerPageDropdownStandalone } from 'react-bootstrap-table2-paginator';
import { Fetcher } from "../../../Helpers/fetcher.js";
import { Notify } from "../../../Helpers/notification.js";
import ReactTooltip from 'react-tooltip';
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
import 'react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min.css';
import 'react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css';
import Dropdown from 'react-bootstrap/Dropdown';
import Cookies from 'js-cookie';

import "./index.css";
import { MODULE_LISTING_CONSTANT } from '../../../Helpers/constant.js';
import { fetchDialersFast } from '../../../Helpers/subSuperAdmin.api.js';
class CampaignManagement extends Component {
    constructor(props) {

        super(props);
        this.state = {
            dialerList: [],
            campaignList: [],
            selectedCampaigns: [],
            availableCampaigns: [],
            locationDialerCampaignList: [],
            runningCampaignList: [],
            confirmEditCampaigns: false,
            confirmRemoveCampaign: false,
            confirmRemoveCampaignSpecial: false,
            confirmAddCampaign: false,
            confirmAddCampaignSpecial: false,
            campaignToRemove: null,
            campaignToAdd: null,
            selectedEditCampaignLocation: '',
            selectedEditCampaignDialerId: '',
            sizePerPage: 10,
            activeTab: 'add',
            addCampaigns: [],
            removeCampaigns: [],
            selectedAddCampaigns: [],
            selectedRemoveCampaigns: [],
            selectedType: 'CAMPAIGN',
            percentage: '',
            loading: true
        }
    }
    componentDidMount() {
        this.loadData();
        const savedSizePerPage = Cookies.get('manageCampSupAdmListsizePerPage');
        if (savedSizePerPage) {
            this.setState({ sizePerPage: Number(savedSizePerPage) });
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevState.selectedType !== this.state.selectedType) {
            this.loadData();
        }
    }

    loadData = async () => {
        this.setState({ loading: true, campaignList: [] });
        try {
            let dialerList
            if (this.state.selectedType == 'CAMPAIGN') {
                dialerList = await this.getDialer();
            } else {
                dialerList = await this.getDialerSpecial();
            }
            await this.getDialerCampaigns(dialerList);
        } catch (err) {
            console.log('Error in fetching data', err);
        } finally {
            this.setState({ loading: false });
        }
    }

    getDialer = async () => {
        const apiPath = this.props.app.apiPath;
        const response = await fetchDialersFast({
            apiPath: apiPath,
            isSubSuperAdmin: this.props.app.isSubSuperAdmin,
            moduleListingData: this.props.app.moduleListingData,
            filterKey: MODULE_LISTING_CONSTANT.MANAGE_DIALERS
        });
        this.setState({
            dialerList: response
        })
        return response;
    }

    getDialerSpecial = async () => {
        const apiPath = this.props.app.apiPath;
        try {
            const response = await Fetcher.get(apiPath + '/api/obd/dialers/special');
            const data = Array.isArray(response) ? response : []
            this.setState({
                dialerList: data
            })
            return data;
        } catch (error) {
            console.log("error", error)
            return []
        }
    }

    getDialerCampaigns = async (dialerList) => {
        const apiPath = this.props.app.apiPath;
        return Fetcher.get(apiPath + '/api/obd/get/campaign/allocation')
            .then(res => {
                if (res.message === "Error While hitting url") {
                    Notify.notify(res.message);
                    return;
                }
                const campaignList = this.transformDialerData(res, dialerList);
                this.setState({
                    campaignList: campaignList,
                    locationDialerCampaignList: res
                });
            })
            .catch(err => { console.log('Error in fetching Dialer Campaigns', err) });
    }

    transformDialerData = (data, dialerList) => {
        const campaignList = [];

        const allowedDialerIds = new Set(
            dialerList.map(d => d.dialerId.toString())
        );

        Object.keys(data).forEach(location => {
            const dialers = data[location];

            Object.keys(dialers).forEach(dialerId => {
                if (!allowedDialerIds.has(dialerId)) return;
                const campaigns = dialers[dialerId];
                const dialerName = dialerList.find(dialer => dialer.dialerId.toString() === dialerId)?.dialerName || `Dialer ${dialerId}`;
                const campaignNames = Object.values(campaigns).map(campaign => campaign.cmpName);

                if (campaignNames.length === 0) {
                    campaignNames.push('No Campaigns Assigned');
                }

                campaignList.push({
                    location,
                    dialerName,
                    dialerId,
                    campaignList: campaignNames
                });
            });
        });

        return campaignList;
    };

    getRunningCampaigns = async () => {
        try {
            const apiPath = this.props.app.apiPath;
            const userId = this.props.app.userId;
            const response = await Fetcher.get(apiPath + '/api/obd/get/running/campaigns/' + userId);
            const data = Array.isArray(response) ? response : []
            this.setState({
                runningCampaignList: data
            })
            return data;
        } catch (error) {
            console.log("error", error)
            return []
        }
    }

    editCampaigns = async (status, location, dialerId) => {
        this.setState({
            confirmEditCampaigns: status,
            selectedEditCampaignLocation: location,
            selectedEditCampaignDialerId: dialerId,
            selectedCampaigns: [],
            initiallySelectedCampaigns: [],
            availableCampaigns: []
        });

        if (status) {
            const runningCampaignList = await this.getRunningCampaigns();
            this.transformCampaignData(runningCampaignList, status, location, dialerId)
            const selectedDialers = [parseInt(dialerId)]
            const selectedCampaigns = [];
            for (let dialerId of selectedDialers) {
                const campaigns = this.state.locationDialerCampaignList[location][dialerId];
                for (let campaignId in campaigns) {
                    selectedCampaigns.push(campaignId);
                }
            }

            const availableCampaigns = [];
            const dialerCampaigns = this.state.locationDialerCampaignList[location][dialerId];
            for (let campaignId in dialerCampaigns) {
                const campaign = dialerCampaigns[campaignId];
                if (!runningCampaignList.some(runningCampaign => runningCampaign.campaignId === campaign.cid)) {
                    availableCampaigns.push(campaign);
                }
            }
            const availableCampaignIds = availableCampaigns.map(campaign => `${campaign.cid}`);
            const selectedCampaignIds = selectedCampaigns.filter(campaignId => availableCampaignIds.includes(campaignId) && runningCampaignList.some(runningCampaign => runningCampaign.campaignId.toString() === campaignId));
            runningCampaignList.forEach(runningCampaign => {
                const existingCampaign = availableCampaigns.find(campaign => campaign.cid.toString() === runningCampaign.campaignId.toString());
                if (!existingCampaign) {
                    if (!availableCampaigns.some(campaign => campaign.cid === runningCampaign.campaignId)) {
                        availableCampaigns.push({
                            cid: runningCampaign.campaignId,
                            cmpName: runningCampaign.campaignName,
                        });
                    }
                }
            });
            // console.log({ selectedCampaignIds, selectedCampaigns, availableCampaigns })
            this.setState({
                selectedCampaigns: selectedCampaigns,
                initiallySelectedCampaigns: selectedCampaigns,
                availableCampaigns: availableCampaigns
            });
        }

    }

    transformCampaignData = (runningCampaignList, status, location, dialerId) => {
        const dialerCampaigns =
            this.state.locationDialerCampaignList?.[location]?.[dialerId] || {};

        const assignedCampaigns = Object.values(dialerCampaigns);
        const removeCampaigns = assignedCampaigns;
        const addCampaigns = runningCampaignList
            .filter(r => !assignedCampaigns.some(c => c.cid.toString() === r.campaignId.toString()))
            .map(r => ({
                cid: r.campaignId,
                cmpName: r.campaignName
            }));
        this.setState({
            addCampaigns,
            removeCampaigns,
            selectedAddCampaigns: [],
            selectedRemoveCampaigns: []
        });
        // console.log({ removeCampaigns, addCampaigns })
    }

    handleCampaignSelect = async (selectedValue) => {
        const { selectedCampaigns, initiallySelectedCampaigns, selectedType } = this.state;
        if (selectedValue === "") {
            this.setState({
                selectedCampaigns: [],
            });
        } else {
            if (selectedCampaigns.includes(selectedValue)) {
                this.setState({
                    confirmRemoveCampaignSpecial: true,
                    campaignToRemove: selectedValue,
                });
                if (selectedType === 'SPECIAL') {
                    await this.getPercentageSuccess();
                }

            } else {
                this.setState({
                    confirmAddCampaignSpecial: true,
                    campaignToAdd: selectedValue,
                });
            }
        }
    }

    getPercentageSuccess = async () => {
        const { selectedCampaigns, locationDialerCampaignList, selectedEditCampaignLocation, selectedEditCampaignDialerId, campaignToRemove } = this.state;
        let dataToSend = [];

        selectedCampaigns.forEach(campaignId => {
            if (locationDialerCampaignList[selectedEditCampaignLocation] && locationDialerCampaignList[selectedEditCampaignLocation][selectedEditCampaignDialerId]) {
                const campaigns = locationDialerCampaignList[selectedEditCampaignLocation][selectedEditCampaignDialerId];
                if (campaigns[campaignToRemove]) {
                    dataToSend = {
                        campaignId: campaigns[campaignToRemove].cid,
                        campaignName: campaigns[campaignToRemove].cmpName,
                        location: selectedEditCampaignLocation,
                        dialerId: selectedEditCampaignDialerId
                    };
                }
            }
        });

        if (Object.keys(dataToSend).length === 0) {
            const selectedCmp = this.state.availableCampaigns.find(campaign => campaign.cid.toString() === campaignToRemove);
            dataToSend = {
                campaignId: campaignToRemove,
                campaignName: selectedCmp?.cmpName,
                location: selectedEditCampaignLocation,
                dialerId: selectedEditCampaignDialerId
            };
        }

        const apiPath = this.props.app.apiPath;
        let response = await Fetcher.get(apiPath + `/api/obd/dialers/getsuccess/${dataToSend.dialerId}/${dataToSend.campaignId}`);
        response = Number(response) || "0"
        this.setState({
            percentage: response
        })
        return response;
    }

    handleTypeChange = (e) => {
        if (e.target.value === "SPECIAL") {
            this.setState({ activeTab: "special", selectedType: e.target.value })
        } else {

            this.setState({ activeTab: "add", selectedType: e.target.value });
        }
    }

    handleSelectAllAdd = () => {
        const all = this.state.addCampaigns.map(c => ({
            id: c.cid,
            name: c.cmpName,
        }));

        this.setState({ selectedAddCampaigns: all });
    };

    handleDeselectAllAdd = () => {
        this.setState({ selectedAddCampaigns: [] });
    };

    handleSelectAllRemove = () => {
        const all = this.state.removeCampaigns.map(c => ({
            id: c.cid,
            name: c.cmpName,
        }));

        this.setState({ selectedRemoveCampaigns: all });
    };

    handleDeselectAllRemove = () => {
        this.setState({ selectedRemoveCampaigns: [] });
    };

    handleAddSelect = (id, name) => {
        this.setState(prev => {
            const exists = prev.selectedAddCampaigns.find(i => i.id === id);
            return {
                selectedAddCampaigns: exists
                    ? prev.selectedAddCampaigns.filter(i => i.id !== id)
                    : [...prev.selectedAddCampaigns, { id, name }]
            };
        });
    };

    handleRemoveSelect = (id, name) => {
        this.setState(prev => {
            const exists = prev.selectedRemoveCampaigns.find(i => i.id === id);
            return {
                selectedRemoveCampaigns: exists
                    ? prev.selectedRemoveCampaigns.filter(i => i.id !== id)
                    : [...prev.selectedRemoveCampaigns, { id, name }]
            };
        });
    };

    removeCampaign = () => {
        const { selectedRemoveCampaigns, selectedEditCampaignLocation, selectedEditCampaignDialerId } = this.state;
        if (selectedRemoveCampaigns.length === 0) {
            Notify.notify("Select at least one campaign");
            return;
        }
        const payload = {
            campaignIds: selectedRemoveCampaigns.map(c => c.id).join(","),
            campaignNames: selectedRemoveCampaigns.map(c => c.name).join(","),
            location: selectedEditCampaignLocation,
            dialerId: selectedEditCampaignDialerId
        };
        return Fetcher.post(this.props.app.apiPath + '/api/obd/campaign/remove', {
            headers: { "Content-type": "application/json" },
            method: 'POST',
            body: JSON.stringify(payload)
        })
            .then(res => {
                if (res.message === 'Parameters Incorrect') {
                    Notify.notify('Update Failed');
                } else {
                    Notify.notify(res.message);
                    // Was a hard window.location.reload() -- a full reload of this
                    // deep route re-triggers the sub-superadmin's async ACL/permission
                    // fetch from scratch, and if that races or fails the page is left
                    // blank with the edit icon gone (hasPermission stuck on the empty
                    // default). Refreshing the in-app data avoids both re-navigating
                    // and re-running that ACL fetch at all.
                    this.loadData();
                }
                this.setState({ confirmEditCampaigns: false, confirmRemoveCampaign: false });

            })
            .catch(err => {
                console.log('Error in removing campaigns', err);
                Notify.notify('Error in removing campaigns');
            });
    }

    addCampaign = () => {
        const { selectedAddCampaigns, selectedEditCampaignLocation, selectedEditCampaignDialerId } = this.state;

        if (selectedAddCampaigns.length === 0) {
            Notify.notify("Select at least one campaign");
            return;
        }

        const payload = {
            campaignIds: selectedAddCampaigns.map(c => c.id).join(","),
            campaignNames: selectedAddCampaigns.map(c => c.name).join(","),
            location: selectedEditCampaignLocation,
            dialerId: selectedEditCampaignDialerId
        };
        return Fetcher.post(this.props.app.apiPath + '/api/obd/campaign/add', {
            headers: { "Content-type": "application/json" },
            method: 'POST',
            body: JSON.stringify(payload)
        })
            .then(res => {
                if (res.message === 'Parameters Incorrect') {
                    Notify.notify('Update Failed');
                } else {
                    Notify.notify(res.message);
                    // See removeCampaign -- avoid the hard reload so the sub-superadmin's
                    // ACL/permission state (and the edit icon it gates) never has to be
                    // re-fetched from scratch on this deep route.
                    this.loadData();
                }
                this.setState({ confirmEditCampaigns: false, confirmAddCampaign: false });

            })
            .catch(err => {
                console.log('Error in adding campaigns', err);
                Notify.notify('Error in adding campaigns');
            });
    }

    handleSizePerPageChange = (newSizePerPage) => {
        this.setState({ sizePerPage: newSizePerPage });
        Cookies.set('manageCampSupAdmListsizePerPage', newSizePerPage);
    }

    removeCampaignSpecial = () => {
        const { selectedCampaigns, locationDialerCampaignList, selectedEditCampaignLocation, selectedEditCampaignDialerId, campaignToRemove } = this.state;
        let dataToSend = [];

        selectedCampaigns.forEach(campaignId => {
            if (locationDialerCampaignList[selectedEditCampaignLocation] && locationDialerCampaignList[selectedEditCampaignLocation][selectedEditCampaignDialerId]) {
                const campaigns = locationDialerCampaignList[selectedEditCampaignLocation][selectedEditCampaignDialerId];
                if (campaigns[campaignToRemove]) {
                    dataToSend = {
                        campaignIds: campaigns[campaignToRemove].cid,
                        campaignNames: campaigns[campaignToRemove].cmpName,
                        location: selectedEditCampaignLocation,
                        dialerId: selectedEditCampaignDialerId
                    };
                }
            }
        });

        if (Object.keys(dataToSend).length === 0) {
            const selectedCmp = this.state.availableCampaigns.find(campaign => campaign.cid.toString() === campaignToRemove);
            dataToSend = {
                campaignIds: campaignToRemove,
                campaignNames: selectedCmp.cmpName,
                location: selectedEditCampaignLocation,
                dialerId: selectedEditCampaignDialerId
            };
        }

        return Fetcher.post(this.props.app.apiPath + '/api/obd/campaign/remove', {
            headers: { "Content-type": "application/json" },
            method: 'POST',
            body: JSON.stringify(dataToSend)
        })
            .then(res => {
                if (res.message === 'Parameters Incorrect') {
                    this.state.confirmEditCampaigns = false
                    Notify.notify('Update Failed');
                } else {
                    this.state.confirmEditCampaigns = false
                    Notify.notify(res.message);
                    // See removeCampaign -- avoid the hard reload so the sub-superadmin's
                    // ACL/permission state (and the edit icon it gates) never has to be
                    // re-fetched from scratch on this deep route.
                    this.loadData();
                }
            })
            .catch(err => {
                console.log('Error in removing campaigns', err);
                Notify.notify('Error in removing campaigns');
            });
    }

    addCampaignSpecial = () => {
        const { selectedCampaigns, locationDialerCampaignList, selectedEditCampaignLocation, selectedEditCampaignDialerId, campaignToAdd, selectedType, percentage } = this.state;
        let dataToSend = {};
        let dataToSendSpecial = {};

        if (selectedType == 'SPECIAL' && percentage == '') {
            Notify.notify('Please Add the Percentage');
            return
        }


        selectedCampaigns.forEach(campaignId => {
            if (locationDialerCampaignList[selectedEditCampaignLocation] && locationDialerCampaignList[selectedEditCampaignLocation][selectedEditCampaignDialerId]) {
                const campaigns = locationDialerCampaignList[selectedEditCampaignLocation][selectedEditCampaignDialerId];
                if (campaigns[campaignToAdd]) {
                    dataToSend = {
                        campaignIds: campaignId,
                        campaignNames: campaigns[campaignToAdd].cmpName,
                        location: selectedEditCampaignLocation,
                        dialerId: selectedEditCampaignDialerId
                    };
                    dataToSendSpecial = {
                        campaignId: campaignId,
                        campaignName: campaigns[campaignToAdd].cmpName,
                        location: selectedEditCampaignLocation,
                        dialerId: selectedEditCampaignDialerId
                    };
                }
            }
        });


        if (Object.keys(dataToSend).length === 0) {
            const selectedCmp = this.state.availableCampaigns.find(campaign => campaign.cid.toString() === campaignToAdd);
            dataToSend = {
                campaignIds: campaignToAdd,
                campaignNames: selectedCmp.cmpName,
                location: selectedEditCampaignLocation,
                dialerId: selectedEditCampaignDialerId
            };
            dataToSendSpecial = {
                campaignId: campaignToAdd,
                campaignName: selectedCmp.cmpName,
                location: selectedEditCampaignLocation,
                dialerId: selectedEditCampaignDialerId
            };
        }

        let url = '/api/obd/dialers/setsuccess';
        let finalData;
        let finalDataSpecial = {
            ...dataToSendSpecial,
            percentage: percentage
        };;


        return Fetcher.post(this.props.app.apiPath + url, {
            headers: { "Content-type": "application/json" },
            method: 'POST',
            body: JSON.stringify(finalDataSpecial)
        })
            .then(res => {
                if (res.message === 'Parameters Incorrect') {
                    this.setState({ confirmEditCampaigns: false });
                    Notify.notify('Update Failed');
                } else {
                    this.setState({ confirmEditCampaigns: false });
                    console.log("inside this : ");
                    if (selectedType === 'SPECIAL') {
                        this.addAfterSpecialDialerPercentage(dataToSend);
                    }
                    else {
                        Notify.notify(res.message);
                        this.loadData();
                    }

                }
            })
            .catch(err => {
                console.log('Error in Setting Percentage', err);
                Notify.notify('Error in adding campaigns');
            });
    }

    addAfterSpecialDialerPercentage = (data) => {

        console.log("data : " + data);
        var url = '/api/obd/campaign/add';
        var finalData = data;

        return Fetcher.post(this.props.app.apiPath + url, {
            headers: { "Content-type": "application/json" },
            method: 'POST',
            body: JSON.stringify(finalData)
        })
            .then(res => {
                if (res.message === 'Parameters Incorrect') {
                    this.setState({ confirmEditCampaigns: false });
                    Notify.notify('Update Failed');
                } else {
                    this.setState({ confirmEditCampaigns: false });
                    Notify.notify(res.message);
                    this.loadData();
                }
            })
            .catch(err => {
                console.log('Error in adding campaigns', err);
                Notify.notify('Error in adding campaigns');
            });

    }

    render() {
        const campaignList = this.state.campaignList;
        let columns = [
            {
                dataField: 'location',
                text: 'Location',
                sort: true,
                searchable: true
            },
            {
                dataField: 'dialerName',
                text: 'Dialer Name',
                sort: true,
                searchable: true
            },
            {
                dataField: 'dialerId',
                text: 'Dialer Id',
                sort: false,
                hidden: true
            },
            {
                dataField: 'campaignList',
                text: 'Campaign List',
                sort: true,
                searchable: true,
                formatter: (cellContent, row) => (
                    <Dropdown>
                        <Dropdown.Toggle variant="success" className="btn-sm" id="dropdown-basic">
                            Campaign List
                        </Dropdown.Toggle>
                        <Dropdown.Menu>
                            {row.campaignList.map((campaign, index) => (
                                <Dropdown.Item key={index}>{campaign}</Dropdown.Item>
                            ))}
                        </Dropdown.Menu>
                    </Dropdown>
                )
            },
            {
                dataField: 'action',
                text: 'Action',
                sort: false,
                searchable: false,
                formatter: (cellContent, row) => (
                    this.props.app.hasPermission('Manage Campaign.Manage Campaigns', 'edit')
                        ? <a className="edit-dialer" key={`${row.dialerId}-allocate-api-cli`} onClick={(e) => { this.editCampaigns(true, row.location, row.dialerId) }} href="#"><i className="fa fa-edit"></i></a>
                        : null
                )
            },];

        const { SearchBar, ClearSearchButton } = Search;

        const defaultSorted = [{
            dataField: 'dialerId',
            order: 'desc'
        }];

        const paginationOption = {
            custom: true,
            totalSize: campaignList.length ?? 0,
            sizePerPage: this.state.sizePerPage,
            sizePerPageList: [10, 25, 50, 100],
            onSizePerPageChange: this.handleSizePerPageChange
        };

        return (
            <Card>
                {/*<Card.Header>Users List<span>&nbsp;&nbsp;&nbsp;</span><span className="float-none avail-credit-cont"><span className="credits-avail">Available Credits: {this.state.adminCredits}</span></span></Card.Header>*/}
                <Card.Header>Campaign List</Card.Header>
                <Card.Body>
                    <div className="widget-list-table-cont">
                        {/* <h3>Campaign Summary</h3> */}
                        {/*{!isEmpty( this.state.dialerList ) && <PaginationProvider pagination={paginationFactory( paginationOption )}>*/}
                        {<PaginationProvider pagination={paginationFactory(paginationOption)}>
                            {
                                ({
                                    paginationProps,
                                    paginationTableProps
                                }) => (
                                    <ToolkitProvider
                                        keyField="dialerId"
                                        data={campaignList}
                                        columns={columns}
                                        search
                                        bootstrap4

                                    >
                                        {
                                            props => (
                                                <div className="">
                                                    <div className="d-flex align-items-center flex-wrap gap-2">
                                                        <span>
                                                            Show{' '}
                                                            <SizePerPageDropdownStandalone
                                                                className="search-dropdown d-inline-block"
                                                                {...paginationProps}
                                                            />{' '}
                                                            items
                                                        </span>

                                                        <Form.Select
                                                            value={this.state.selectedType}
                                                            onChange={this.handleTypeChange}
                                                            style={{ width: '150px', marginTop: '15px', marginLeft: '10px' }}
                                                        >
                                                            <option value="CAMPAIGN">Campaign</option>
                                                            <option value="SPECIAL">Special</option>
                                                        </Form.Select>

                                                        <span className="search-cont">
                                                            <SearchBar {...props.searchProps} />
                                                        </span>

                                                        <ClearSearchButton
                                                            className="btn-primary btn-round"
                                                            {...props.searchProps}
                                                        />

                                                    </div>
                                                    {/*<span>&nbsp;&nbsp;&nbsp;</span><span className="float-none avail-credit-cont"><span className="credits-avail">Available Credits: {this.state.adminCredits}</span></span>*/}
                                                    {/*<Link className="float-right btn btn-default btn-primary" to={`${this.props.app.urlPrefix}/add-cli`}>Allocate CLI</Link>*/}

                                                    <BootstrapTable defaultSorted={defaultSorted} bordered={true} hover condensed wrapperClasses="table-responsive" classes="mt-3  widgetlist-table"  {...props.baseProps}  {...paginationTableProps} noDataIndication={() => (<div>{'No data available'}</div>)} />
                                                    <PaginationListStandalone {...paginationProps} />
                                                    <ReactTooltip />
                                                </div>
                                            )
                                        }
                                    </ToolkitProvider>
                                )
                            }
                        </PaginationProvider>}
                    </div>
                    <Modal size="md" show={this.state.confirmEditCampaigns} onHide={() => this.editCampaigns(false, '')}>
                        <Modal.Header closeButton>
                            <Modal.Title id="example-modal-sizes-title-sm">
                                Update Campaigns
                            </Modal.Title>
                        </Modal.Header>
                        <Modal.Body >
                            <Tabs
                                activeKey={this.state.activeTab}
                                onSelect={(k) => this.setState({ activeTab: k })}
                            >
                                {this.state.selectedType !== "SPECIAL" && (
                                    [
                                        <Tab eventKey="add" title="Add Campaign" key="add">
                                            {this.state.addCampaigns?.length > 0 && (
                                                <Form.Check
                                                    type="checkbox"
                                                    label={
                                                        this.state.selectedAddCampaigns.length === this.state.addCampaigns.length
                                                            ? "Deselect All"
                                                            : "Select All"
                                                    }
                                                    id='select-all-add'
                                                    checked={this.state.selectedAddCampaigns.length === this.state.addCampaigns.length}
                                                    onChange={(e) =>
                                                        e.target.checked
                                                            ? this.handleSelectAllAdd()
                                                            : this.handleDeselectAllAdd()
                                                    }
                                                />)}
                                            <div style={{ maxHeight: '400px', overflowY: 'auto' }}>
                                                {this.state.addCampaigns?.length === 0 ? (
                                                    <p className="mt-2">No campaigns available to add</p>
                                                ) : (
                                                    this.state.addCampaigns.map(c => (
                                                        <Form.Check
                                                            key={c.cid}
                                                            id={`add-${c.cid}`}
                                                            label={c.cmpName}
                                                            checked={this.state.selectedAddCampaigns.some(item => item.id === c.cid)}
                                                            onChange={() => this.handleAddSelect(c.cid, c.cmpName)}
                                                        />
                                                    ))
                                                )}
                                            </div>
                                            <div className="mt-3 text-left">
                                                <Button variant="primary" onClick={() => this.setState({ confirmAddCampaign: true })}>
                                                    Add
                                                </Button>
                                            </div>
                                        </Tab>,

                                        <Tab eventKey="remove" title="Remove Campaign" key="remove">
                                            {this.state.removeCampaigns?.length > 0 && (
                                                < Form.Check
                                                    type="checkbox"
                                                    label={
                                                        this.state.selectedRemoveCampaigns.length === this.state.removeCampaigns.length
                                                            ? "Select All"
                                                            : "Deselect All"
                                                    }
                                                    id='select-all-remove'
                                                    checked={this.state.selectedRemoveCampaigns.length !== this.state.removeCampaigns.length}
                                                    onChange={(e) =>
                                                        e.target.checked
                                                            ? this.handleDeselectAllRemove()
                                                            : this.handleSelectAllRemove()
                                                    }
                                                />)}
                                            <div style={{ maxHeight: '400px', overflowY: 'auto' }}>
                                                {this.state.removeCampaigns?.length === 0 ? (
                                                    <p className="mt-2">No campaigns to remove</p>
                                                ) : (
                                                    this.state.removeCampaigns.map(c => (
                                                        <Form.Check
                                                            key={c.cid}
                                                            id={`remove-${c.cid}`}
                                                            label={c.cmpName}
                                                            checked={!this.state.selectedRemoveCampaigns.some(item => item.id === c.cid)}
                                                            onChange={() => this.handleRemoveSelect(c.cid, c.cmpName)}
                                                        />
                                                    ))
                                                )}
                                            </div>

                                            <div className="mt-3 text-left">
                                                <Button variant="danger" onClick={() => this.setState({ confirmRemoveCampaign: true })}>
                                                    Remove
                                                </Button>
                                            </div>
                                        </Tab>
                                    ]
                                )}

                                {this.state.selectedType === "SPECIAL" && (
                                    <Tab eventKey="special" title="Special Campaign">
                                        <Row>
                                            <Col>
                                                <Form.Group className="form-group channels control-label">
                                                    <Form.Label>Select Campaign</Form.Label>
                                                    {this.state.availableCampaigns.length === 0 ? (
                                                        <p>No campaigns available</p>
                                                    ) : (
                                                        this.state.availableCampaigns.map(campaign => (
                                                            <Form.Check
                                                                key={campaign.cid}
                                                                type="checkbox"
                                                                label={campaign.cmpName}
                                                                id={`campaign-${campaign.cid}`}
                                                                value={campaign.cid}
                                                                checked={this.state.selectedCampaigns.includes(`${campaign.cid}`)}
                                                                onChange={(e) => this.handleCampaignSelect(e.target.value)}
                                                            />
                                                        ))
                                                    )}
                                                </Form.Group>
                                            </Col>
                                        </Row>
                                    </Tab>
                                )}
                            </Tabs>
                        </Modal.Body>
                    </Modal>
                    <Modal size="md" show={this.state.confirmRemoveCampaign} onHide={() => this.setState({ confirmRemoveCampaign: false })}>
                        <Modal.Header closeButton>
                            <Modal.Title>Remove Campaign</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            Are you sure you want to remove selected campaign?
                        </Modal.Body>
                        <Modal.Footer>
                            <Button variant="secondary" onClick={() => this.setState({ confirmRemoveCampaign: false })}>Cancel</Button>
                            <Button variant="primary" onClick={this.removeCampaign}>Yes</Button>
                        </Modal.Footer>
                    </Modal>

                    <Modal size="md" show={this.state.confirmAddCampaign} onHide={() => this.setState({ confirmAddCampaign: false })}>
                        <Modal.Header closeButton>
                            <Modal.Title>Add Campaign</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            Are you sure you want to add selected campaign?
                        </Modal.Body>
                        <Modal.Footer>
                            <Button variant="secondary" onClick={() => this.setState({ confirmAddCampaign: false })}>Cancel</Button>
                            <Button variant="primary" onClick={this.addCampaign}>Yes</Button>
                        </Modal.Footer>
                    </Modal>

                    <Modal size="md" show={this.state.confirmRemoveCampaignSpecial} onHide={() => this.setState({ confirmRemoveCampaignSpecial: false })}>
                        <Modal.Header closeButton>
                            <Modal.Title>Remove Campaign</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            Are you sure you want to remove selected campaign?
                            <Form.Group className="mt-3">
                                <Form.Label>Percentage</Form.Label>
                                <Form.Control
                                    type="number"
                                    name="percentage"
                                    placeholder="Enter percentage"
                                    min={1}
                                    max={100}
                                    value={this.state.percentage}
                                    onChange={(e) => {
                                        const value = e.target.value;

                                        if (value === '') {
                                            this.setState({ percentage: '' });
                                            return;
                                        }

                                        const num = Number(value);

                                        if (num >= 1 && num <= 100) {
                                            this.setState({ percentage: num });
                                        }
                                    }}
                                />
                                <small className="text-muted">Range: 1 – 100</small>
                            </Form.Group>
                        </Modal.Body>
                        <Modal.Footer>
                            <Button variant="secondary" onClick={this.addCampaignSpecial}>Edit Percentage</Button>
                            <Button variant="secondary" onClick={() => this.setState({ confirmRemoveCampaignSpecial: false })}>Cancel</Button>
                            <Button variant="primary" onClick={this.removeCampaignSpecial}>Yes</Button>
                        </Modal.Footer>
                    </Modal>

                    <Modal size="md" show={this.state.confirmAddCampaignSpecial} onHide={() => this.setState({ confirmAddCampaignSpecial: false })}>
                        <Modal.Header closeButton>
                            <Modal.Title>Add Campaign</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            Are you sure you want to add selected campaign?
                            <Form.Group className="mt-3">
                                <Form.Label>Percentage</Form.Label>
                                <Form.Control
                                    type="number"
                                    name="percentage"
                                    placeholder="Enter percentage"
                                    min={1}
                                    max={100}
                                    value={this.state.percentage}
                                    onChange={(e) => {
                                        const value = e.target.value;

                                        if (value === '') {
                                            this.setState({ percentage: '' });
                                            return;
                                        }

                                        const num = Number(value);

                                        if (num >= 1 && num <= 100) {
                                            this.setState({ percentage: num });
                                        }
                                    }}
                                />
                                <small className="text-muted">Range: 1 – 100</small>
                            </Form.Group>
                        </Modal.Body>
                        <Modal.Footer>
                            <Button variant="secondary" onClick={() => this.setState({ confirmAddCampaignSpecial: false })}>Cancel</Button>
                            <Button variant="primary" onClick={this.addCampaignSpecial}>Yes</Button>
                        </Modal.Footer>
                    </Modal>

                    {(this.state.loading === true) && <div className="fetching-data"><img alt="" src="/assets/loading.gif" /></div>}

                </Card.Body>
            </Card>

        );
    }
}

export default CampaignManagement;